import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import {Form} from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';

function RegisterTest() {
  const [validated, setValidated] = useState(false);

  const handleSend = (event) => {
    const form = event.currentTarget;
    console.log(form)
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSend}>
      <Form.Control required type="text" placeholder="First name" />
      <button type="submit">Submit form</button>
    </Form>
  );
}

export default RegisterTest;
